export const SPONSOR_MOBILE_BREAKPOINT = 768;

export const INITIAL_SPONSOR_FILTER = {
    limit: 10,
    page: 1,
    sort: 'desc-id',
    search: '',
};

export const SPONSOR_BANNER_STYLES = {
    content: {
        height: '200px',
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'center',
        flexDirection: 'column',
        backgroundColor: '#d5e8eb',
        borderRadius: '8px',
        paddingBlock: '25px',
        paddingInline: '50px',
    },
    title: {
        textTransform: 'uppercase',
        color: '#2e2525ff',
        fontWeight: '600',
        fontSize: '40px',
    },
    breadcrumb: {
        fontSize: '20px',
        fontWeight: '500',
    },
};
